module.exports = __webpack_public_path__ + "img/ff-create-channel.542e29f1.jpg";